import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Badge } from '../../material-ui/Badge';
import { ListItem, ListItemIcon, ListItemText } from '../../material-ui/List';
import { Library } from '../../../icons';
import { getLibraryNotifications } from '../../../selectors/library';
import { useStyles } from './useStyles';

export const LibraryAdapter = memo(({ value, selected, onClick, className }) => {
    const libraryWithWarning = useSelector(getLibraryNotifications) || [];

    const { t: translate } = useTranslation();
    const classes = useStyles();

    const handleClick = useCallback(() => onClick(value), [onClick]);

    return (
        <ListItem onClick={handleClick} button={true} selected={selected}>
            <ListItemIcon className={classes.listIcon}>
                <Badge
                    badgeContent={libraryWithWarning.length}
                    color="secondary"
                    max={999}
                    classes={{ anchorOriginTopRightRectangular: classes.badge }}
                >
                    <Library width="24" height="24" />
                </Badge>
            </ListItemIcon>
            <ListItemText primary={translate('labels.library')} className={className} />
        </ListItem>
    );
});

LibraryAdapter.displayName = 'LimitationAdapter';
